/** Rounds an axis maximum up to a clean 1 / 2 / 5 x 10^n tick value. */
export function niceMax(value: number, tickCount = 4): number {
  if (value <= 0) return tickCount;
  const rough = value / tickCount;
  const magnitude = 10 ** Math.floor(Math.log10(rough));
  const normalised = rough / magnitude;
  const step = normalised <= 1 ? 1 : normalised <= 2 ? 2 : normalised <= 5 ? 5 : 10;
  // Everything charted is a count, so a tick never falls between whole numbers.
  return Math.max(1, step * magnitude) * tickCount;
}

export function ticksFor(max: number, count = 4): number[] {
  return Array.from({ length: count + 1 }, (_, index) => (max / count) * index);
}

/** Path for a rect with two rounded corners on the data-end, square at the baseline. */
export function roundedEndRect(
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
  end: 'top' | 'right',
): string {
  if (width <= 0 || height <= 0) return '';
  const r = Math.max(0, Math.min(radius, end === 'top' ? Math.min(height, width / 2) : Math.min(width, height / 2)));

  if (end === 'top') {
    return [
      `M ${x} ${y + height}`,
      `L ${x} ${y + r}`,
      `Q ${x} ${y} ${x + r} ${y}`,
      `L ${x + width - r} ${y}`,
      `Q ${x + width} ${y} ${x + width} ${y + r}`,
      `L ${x + width} ${y + height}`,
      'Z',
    ].join(' ');
  }

  return [
    `M ${x} ${y}`,
    `L ${x + width - r} ${y}`,
    `Q ${x + width} ${y} ${x + width} ${y + r}`,
    `L ${x + width} ${y + height - r}`,
    `Q ${x + width} ${y + height} ${x + width - r} ${y + height}`,
    `L ${x} ${y + height}`,
    'Z',
  ].join(' ');
}

/** Keeps a tooltip inside its container instead of letting it clip at the edge. */
export function clampTooltipLeft(x: number, containerWidth: number, tooltipWidth = 190): number {
  return Math.max(8, Math.min(x - tooltipWidth / 2, containerWidth - tooltipWidth - 8));
}
